import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import type { Route } from 'model';
import { RouteMap } from './RouteMap';
import { ManPage } from 'components/ManPage/ManPage';

export function RouteDetail({ routes }: { routes: Route[] }): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const route = routes.find((r) => r.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!route) {
    return (
      <ManPage
        name="route"
        sections={[
          { heading: 'NAME', body: 'route - not found' },
          {
            heading: 'ERROR',
            body: (
              <>
                The route you're looking for doesn't exist.{'\n'}
                <Link to="/routes">← back to routes(1)</Link>
              </>
            )
          }
        ]}
      />
    );
  }

  return (
    <ManPage
      name={route.id}
      manual="Trail Detail"
      sections={[
        { heading: 'NAME', body: `${route.name} -- ${route.location}` },
        { heading: 'MAP', body: <RouteMap gpxFile={route.gpxFile} /> },
        { heading: 'DESCRIPTION', body: route.description },
        ...(route.tags && route.tags.length > 0 ? [{ heading: 'TAGS', body: `[${route.tags.join(', ')}]` }] : []),
        {
          heading: 'DOWNLOAD',
          body: (
            <a className="man-btn" href={route.gpxFile} download>
              download .gpx
            </a>
          )
        },
        {
          heading: 'SEE ALSO',
          body: <Link to="/routes">routes(1)</Link>
        }
      ]}
    />
  );
}
